import React from 'react'
import { IWizardStepContext, StepName } from '../types'
import { notYetImplementedWithError } from '../../../utils'
import { ComponentWithChildren } from '../../../types'

export interface LocationStepFormData {
  address: string
  apt: string
  city: string
  state: string // TODO: State should be an enum
  zipcode: string
}

const defaultFormData = {
  address: '',
  apt: '',
  city: '',
  state: '',
  zipcode: ''
}

export const LocationStepContext = React.createContext<IWizardStepContext<LocationStepFormData>>({
  name: StepName.Location,
  data: defaultFormData,
  setStepData: notYetImplementedWithError,
  validateStepData: notYetImplementedWithError
})

interface LocationStepProviderProps extends ComponentWithChildren {
  initialData?: LocationStepFormData
}

export const LocationStepProvider: React.FC<LocationStepProviderProps> = ({
  children,
  initialData
}) => {
  const [data, setStepData] = React.useState<LocationStepFormData>(initialData ?? defaultFormData)

  const value = React.useMemo<IWizardStepContext<LocationStepFormData>>(() => {
    const validateStepData = (): void => {
      // TODO: Validate address exists
      if (data.address.length === 0) {
        throw new Error('Address is required')
      }
      if (data.city.length === 0) {
        throw new Error('City is required')
      }
      if (data.state.length === 0) {
        throw new Error('State is required')
      }
      if (data.zipcode.length === 0) {
        throw new Error('Zip is required')
      }
    }

    return {
      name: StepName.Location,
      data,
      setStepData,
      validateStepData
    }
  }, [data])

  return (
    <LocationStepContext.Provider value={value}>
      {children}
    </LocationStepContext.Provider>
  )
}
